import { render, staticRenderFns } from "./tableptos.vue?vue&type=template&id=1ca48574&scoped=true&"
import script from "./tableptos.vue?vue&type=script&lang=js&"
export * from "./tableptos.vue?vue&type=script&lang=js&"
import style0 from "./tableptos.vue?vue&type=style&index=0&id=1ca48574&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca48574",
  null
  
)

export default component.exports